const Footer = () => {
  return (
    <footer className="footer">
      Powered by FIS<sup>®</sup> Everlink™ User Management Portal
    </footer>
  );
};

export default Footer;
